// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2k_X5","footer":"ModalCreateQualiphyProcedure_footer__2O5po","additionData":"ModalCreateQualiphyProcedure_additionData__7-uZ5"};